/**
 * Create Phones context for custom hook
 */
import { createContext } from 'react'

const PhonesContext = createContext({
  validatePhone: () => {}
})

export default PhonesContext
